import { getSupabaseWithJWT, supabase as anonClient } from '@/integrations/supabase/client';

let cachedId: string | null = null;
let inFlight: Promise<string | null> | null = null;
let lastFetched = 0;
const TTL_MS = 2 * 60 * 1000; // 2 minutes

export async function getCurrentProfileIdCached(): Promise<string | null> {
  const now = Date.now();
  if (cachedId && now - lastFetched < TTL_MS) return cachedId;
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      // Prefer authenticated client if available
      let client;
      try {
        client = await getSupabaseWithJWT();
      } catch {
        client = anonClient;
      }
      const { data, error } = await client.rpc('current_profile_id');
      if (error) throw error;
      cachedId = (data as string) || null;
      lastFetched = Date.now();
      return cachedId;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}

